<!-- <div [@openClose]="isAllow ? 'open' : 'closed'" class="modal-permission flex-modal">
  <div class="modal-body">
      <p class="title">Allow Permission</p>
      <p class="content">อนุญาติให้เว็บไซด์นี้ สามารถเก็บข้อมูลของท่านได้</p>
  </div>
  <div class="flex-button">
      <button (click)="isAllowPermission(true)" class="ripple-light bg-light">ยืนยัน</button>
      <button (click)="isAllowPermission(false)" class="ripple-inherit bg-inherit">ไม่ขอบคุณ</button>
  </div>
</div> -->

<div [@openClose]="isAllow ? 'open' : 'closed'" class="uk-position-fixed snakebar">
  <div class="uk-container">
    <!-- <div class="uk-padding-small uk-position-top-right" style="color: red; font-weight: 900; cursor:pointer" (click)="onClose()">X</div> -->
    <div class="uk-grid +text-white">

      <div class="uk-width-expand@m"> 
        <p class="uk-padding-small uk-padding-remove-horizontal uk-padding-remove-bottom uk-text-small +text-read">
          เว็บไซต์นี้มีการเก็บและใช้คุกกี้ เพื่อปรับปรุงคุณภาพของเว็บไซต์มอบประสบการณ์ในการใช้งานที่ดีกับผู้ใช้งาน 
          ท่านสามารถอ่าน <a href="https://www.tisco.co.th/th/cookies-policy.html " target="_bank">นโยบายการใช้คุกกี้</a> 
        </p>
      </div>

      <div class="uk-width-auto@m uk-text-center cookie-btn">
        <!-- <button class="uk-button uk-button-default uk-border-rounded uk-margin-top uk-margin-bottom
          +background-transparent +text-white +border-white +btn-min-160" (click)="isAllowPermission(false)">ไม่ยอมรับ</button> -->

        <button class="uk-button uk-button-default uk-border-rounded uk-margin-top uk-margin-bottom 
          +background-white cookie-setting" uk-toggle="target: #cookie-setting" (click)="toggleBanner()">ตั้งค่าการจัดเก็บคุกกี้</button>

        <button class="uk-button uk-button-primary uk-border-rounded uk-margin-top uk-margin-bottom
          +border-white cookie-accept" (click)="onSubmit(true)">ยอมรับ</button>

        <!-- <button (click)="onClose()" class="ripple-inherit bg-inherit">ไม่ขอบคุณ</button> -->
      </div>

    </div>
  </div>
</div>

<div id="cookie-setting" class="uk-modal-container" uk-modal="esc-close: false; bg-close: false">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-padding-remove background-darkblue">

    <button class="uk-modal-close-default +text-white" type="button" uk-close (click)="toggleBanner()"></button>

    <div class="uk-padding-small">
      <h3 class="uk-modal-title uk-margin-remove-bottom +text-white cookie-title">ตั้งค่าการจัดเก็บคุกกี้</h3>
    </div>

    <form (ngSubmit)="onSubmit()">

      <div class="uk-modal-body uk-padding-small uk-padding-remove-top">
        
        <div class="border-gray">

          <div uk-grid class="cookie-block" (click)="toggleCookieDesc('cookie-important')" uk-toggle="target: #tg-cookie-important; cls: uk-hidden">
            <div uk-grid class="uk-padding-small uk-margin-remove-left">

              <div *ngIf="!cookie_setting.cookie_important.toggle; else Close" class="uk-padding-remove-left">
                <span uk-icon="icon: plus; ratio: 1"></span>
              </div>

              <ng-template #Close>
                <div class="uk-padding-remove-left">
                  <span uk-icon="icon: minus; ratio: 1"></span>
                </div>
              </ng-template>

            </div>

            <div class="uk-width-expand uk-padding-small cookie-name">
              คุกกี้ที่จำเป็น
            </div>

            <div class="uk-padding-small">
              เปิดใช้งานตลอดเวลา
            </div>
          </div>

          <div id="tg-cookie-important" class="uk-hidden uk-padding-small cookie-description">
            <p class="uk-margin-left uk-margin-remove-bottom">
              คุกกี้ประเภทนี้มีความสำคัญในการทำงานพื้นฐานของระบบทำให้ท่านสามารถเยี่ยมชมเว็บไซต์ และการให้บริการต่างๆ ของทิสโก้&nbsp;เช่น&nbsp;บริการออนไลน์&nbsp;แอปพลิเคชันบนโทรศัพท์มือถือ&nbsp;และอื่นๆ&nbsp;&nbsp;หากไม่มีคุกกี้ประเภทนี้ เว็บไซต์หรือฟังก์ชันบางฟังก์ชันบนระบบอาจจะไม่สามารถทำงานได้ตามปกติ รวมทั้งท่านจะไม่สามารถใช้บริการบางอย่างได้ตามที่ร้องขอ<br>
            </p>
          </div>
          
        </div>

        <div class="border-gray">

          <div uk-grid class="cookie-block" (click)="toggleCookieDesc('cookie-performance')" uk-toggle="target: #tg-cookie-usage; cls: uk-hidden">
            <div uk-grid class="uk-padding-small uk-margin-remove-left">

              <div *ngIf="!cookie_setting.cookie_performance.toggle; else Close" class="uk-padding-remove-left">
                <span uk-icon="icon: plus; ratio: 1"></span>
              </div>

              <ng-template #Close>
                <div class="uk-padding-remove-left">
                  <span uk-icon="icon: minus; ratio: 1"></span>
                </div>
              </ng-template>

            </div>

            <div class="uk-width-expand uk-padding-small cookie-name">
              คุกกี้ที่เก็บข้อมูลการใช้งาน
            </div>

            <div class="uk-padding-small">
              <div>
                <input type="checkbox" name="cookie-usage" id="toggle-usage" 
                  [(ngModel)] = "cookie_setting.cookie_performance.checked"
                >
                <label for="toggle-usage"></label>
              </div>
            </div>
          </div>

          <div id="tg-cookie-usage" class="uk-hidden uk-padding-small cookie-description">
            <p class="uk-margin-left uk-margin-remove-bottom">
              คุกกี้ประเภทนี้จะเก็บรวบรวมข้อมูลการใช้งานของท่านบนเว็บไซต์ของทิสโก้&nbsp;เช่น เว็บเพจที่ท่านเข้าชมบ่อยที่สุด&nbsp;รวมถึงลิงก์ที่ท่านคลิกเข้าไปชม&nbsp;ทั้งนี้&nbsp;คุกกี้ประเภทนี้จะไม่เก็บรวบรวมข้อมูลใดๆ&nbsp;ที่สามารถระบุตัวตนของท่านได้&nbsp;โดยทิสโก้จะใช้คุกกี้ประเภทนี้เพื่อเข้าใจถึงวิธีการใช้งานบริการออนไลน์และเว็บไซต์ของทิสโก้ และเพื่อพัฒนาการทำงานของเว็บไซต์และเพิ่มประสิทธิภาพในการให้บริการ<br>
            </p>
          </div>
          
        </div>

        <div class="border-gray">

          <div uk-grid class="cookie-block" (click)="toggleCookieDesc('cookie-functional')" uk-toggle="target: #tg-cookie-performance; cls: uk-hidden">
            <div uk-grid class="uk-padding-small uk-margin-remove-left">

              <div *ngIf="!cookie_setting.cookie_functional.toggle; else Close" class="uk-padding-remove-left">
                <span uk-icon="icon: plus; ratio: 1"></span>
              </div>

              <ng-template #Close>
                <div class="uk-padding-remove-left">
                  <span uk-icon="icon: minus; ratio: 1"></span>
                </div>
              </ng-template>

            </div>

            <div class="uk-width-expand uk-padding-small cookie-name">
              คุกกี้ที่เพิ่มประสิทธิภาพในการใช้งาน
            </div>

            <div class="uk-padding-small">
              <div>
                <input type="checkbox" name="cookie-performance" id="toggle-performance" 
                  [(ngModel)] = "cookie_setting.cookie_functional.checked"
                >
                <label for="toggle-performance"></label>
              </div>
            </div>
          </div>

          <div id="tg-cookie-performance" class="uk-hidden uk-padding-small cookie-description">
            <p class="uk-margin-left uk-margin-remove-bottom">
              คุกกี้ประเภทนี้ช่วยให้เว็บไซต์ของทิสโก้จดจำข้อมูลหรือตัวเลือกที่ท่านได้กำหนดไว้แล้ว (เช่น ชื่อผู้เข้าใช้ ภาษา หรือภูมิภาคที่ท่านอาศัยอยู่) เพื่อให้บริการที่เหมาะสมสำหรับท่านโดยเฉพาะ นอกจากนี้ คุกกี้ประเภทนี้ยังสามารถจดจำการตั้งค่าขนาดหรือรูปแบบตัวอักษร และส่วนอื่นๆ ของเว็บเพจที่ท่านตั้งค่าไว้ได้ คุกกี้ประเภทนี้อาจเก็บรวบรวมข้อมูลที่ไม่สามารถระบุตัวตนได้ และไม่สามารถติดตามกิจกรรมการเยี่ยมชมเว็บไซต์ของท่านบนเว็บไซต์อื่นๆ ได้
            </p>
          </div>
          
        </div>
        
        <div class="border-gray">

          <div uk-grid class="cookie-block" (click)="toggleCookieDesc('cookie-ads')" uk-toggle="target: #tg-cookie-ads; cls: uk-hidden">
            <div uk-grid class="uk-padding-small uk-margin-remove-left">

              <div *ngIf="!cookie_setting.cookie_ads.toggle; else Close" class="uk-padding-remove-left">
                <span uk-icon="icon: plus; ratio: 1"></span>
              </div>

              <ng-template #Close>
                <div class="uk-padding-remove-left">
                  <span uk-icon="icon: minus; ratio: 1"></span>
                </div>
              </ng-template>

            </div>

            <div class="uk-width-expand uk-padding-small cookie-name">
              คุกกี้ที่เพิ่มการกำหนดเป้าหมายหรือเพื่อการโฆษณา
            </div>

            <div class="uk-padding-small">
              <div>
                <input type="checkbox" name="cookie-ads" id="toggle-ads" 
                  [(ngModel)] = "cookie_setting.cookie_ads.checked"
                >
                <label for="toggle-ads"></label>
              </div>
            </div>
          </div>

          <div id="tg-cookie-ads" class="uk-hidden uk-padding-small cookie-description">
            <p class="uk-margin-left uk-margin-remove-bottom">
              คุกกี้ประเภทนี้ใช้สำหรับการนำเสนอโฆษณาที่เกี่ยวข้องและตรงกับความสนใจของท่านมากขึ้น รวมถึงการจำกัดจำนวนการส่งโฆษณาด้วย และยังช่วยตรวจสอบประสิทธิภาพของแคมเปญโฆษณาของทิสโก้ โดยจะถูกใช้งานโดยเครือข่ายสื่อโฆษณา (เช่น Facebook, Google และอื่นๆ) ซึ่งได้รับอนุญาตจากทิสโก้ และจะจดจำวิธีการเยี่ยมชมเว็บไซต์ของทิสโก้ และทิสโก้ อาจเปิดเผยข้อมูลนี้ให้แก่บุคคลอื่นๆ เช่น ผู้ให้บริการสื่อโฆษณา ทั้งนี้ คุกกี้ประเภทนี้มักจะเชื่อมโยงไปยังเว็บไซต์ที่ให้บริการโดยบุคคลอื่น ในกรณีที่ทิสโก้จะใช้คุกกี้ประเภทนี้ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน ทิสโก้จะต้องขอความยินยอมจากท่านหรือดำเนินการตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล&nbsp;พ.ศ.2562&nbsp;กำหนด
              <br><br>หากทิสโก้มีการเชื่อมโยงไปยังเว็บไซต์ของบุคคลที่สาม โปรดทราบว่าบุคคลดังกล่าวอาจมีนโยบายการใช้คุกกี้ของตนเอง ทิสโก้ ขอแนะนำให้ท่านอ่านนโยบายการใช้คุกกี้ของบุคคลดังกล่าวก่อนการใช้งานเว็บไซต์เหล่านั้น
            </p>
          </div>
          
        </div>

      </div>

      <div class="uk-modal-footer uk-padding-small uk-text-right">
        <button class="uk-button uk-button-primary uk-border-rounded 
          +border-white +btn-min-160" type="submit">ยืนยันตัวเลือกของฉัน</button>
      </div>

    </form>

  </div>
</div>